import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// TODO: Delete this
const imageUrl = player => {
  const { image } = player;
  const newImage = image.replace(
    process.env.API_URL,
    'https://cdn.pivotanalysis.app',
  );
  return newImage;
};

const formatHeight = height => {
  const feet = Math.floor(height / 12);
  const inches = height % 12;
  return `${feet}'${inches}"`;
};

const playerDisplayName = player =>
  player.normalized ? player.normalized : player.name;

const Player = ({ player, url }) => (
  <Link
    to={url}
    className="s-players__item is-fade-loaded"
    key={player.id}
    title={player.name}
  >
    <div className="s-players__info">
      <div className="s-players__meta">
        <p className="s-players__id">@{player.id}</p>
        <p className="s-players__name">{playerDisplayName(player)}</p>
        {player.normalized && <p className="s-players__aka">{player.name}</p>}
        <div>
          <span>#{player.jersey}</span>
          &nbsp;&middot;&nbsp;
          <span>{player.position}</span>
          &nbsp;&middot;&nbsp;
          <span>{formatHeight(player.height)}</span>
        </div>
        <div>
          <span>{player.league}</span>
          &nbsp;&middot;&nbsp;
          <span>{player.team}</span>
        </div>
      </div>
      <div className="s-players__image">
        <img src={imageUrl(player)} alt={player.name} />
      </div>
    </div>
  </Link>
);

Player.propTypes = {
  player: PropTypes.object.isRequired,
};

export default Player;
